import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../shared/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { GETClickToEditComponent } from './click-to-edit/get-click-to-edit.component';
import { GETEditDataComponent } from './edit-data/edit-data.component';
import { PipeModule } from '../../../shared/pipes/pipe.module';

@NgModule({
  imports: [
      CommonModule,
      MaterialModule,
      FormsModule,
      ReactiveFormsModule,
    RouterModule,
    PipeModule
    ],
  exports: [
    GETClickToEditComponent,
    GETEditDataComponent ,
  ],
  declarations: [
    GETClickToEditComponent,
    GETEditDataComponent
  ],
  providers: [

  ]
})
export class GETSharedModule { }
